import * as React from "react";
import { ViewMe, EmailOtpRequestController } from "@njoy/controller";
import { withFormik, FormikProps, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton";
import { InputField } from "../../../../shared/InputField";
import * as ROUTES from "../../../../../constants/routes";
import PageLoader from "src/modules/shared/PageLoader";
import ToastMessage from "../../../../../hooks/useToast";
import { extractError } from "../../../../../utils/extractError";

interface ChangeEmailFormValues {
  email: string;
}

interface ChangeEmailProps {
  initialValues?: ChangeEmailFormValues;
  submit?: (values: ChangeEmailFormValues) => Promise<any>;
  onFinish?: (email: string) => void;
}

const ChangeEmailPageInner: React.FC<FormikProps<ChangeEmailFormValues> & ChangeEmailProps> = (props) => {
  return (
    <TemplateSub page="Change Email Address">
      <Form className="flex flex-col mt-8 flex-1 px-[1rem]">
        <div className="w-full flex-1 flex flex-col">
          <label className="text-[#CECECF] opacity-90" htmlFor="email">
            Enter new email address
          </label>
          <Field
            name="email"
            placeholder="Email address"
            component={InputField}
          />
        </div>

        <div className=" mb-[2rem]">
          <NewButton
            loading={props.isSubmitting}
            fullWidth
            variant="primary"
            type="submit"
            className="login-form-button"
            // onClick={() => navigate(ROUTES.CHANGE_EMAIL_OTP)}
          >
            Continue
          </NewButton>
        </div>
      </Form>
    </TemplateSub>
  );
};

const FormikChangeEmailPage = withFormik<
  ChangeEmailProps,
  ChangeEmailFormValues
>({
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    email: props.initialValues?.email || "",
  }),
  handleSubmit: async (values, { props, setErrors, setSubmitting, setTouched }) => {
    try {
      setSubmitting(true);
      if (props.submit) {
        const serverErrors = await props.submit(values);

        if (serverErrors) {
          setSubmitting(false);
          ToastMessage("error", extractError(serverErrors));
          setErrors(serverErrors);
          setTouched(
            Object.keys(serverErrors).reduce(
              (acc, key) => ({ ...acc, [key]: true }),
              {} as Record<string, boolean>
            )
          );
          return;
        }

        setSubmitting(false);
        if (props.onFinish) {
          props.onFinish(values.email);
        }
      }
    } catch (error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message || "Something went wrong. Please try again.");
    }
  },
})(ChangeEmailPageInner as any);

export const ChangeEmailPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <EmailOtpRequestController>
      {({ emailOtpRequest }) => (
        <ViewMe>
          {({ match, loading }) => {
            if (loading || !match) {
              return <PageLoader />;
            }

            const initialValues = {
              email: match?.customer?.email || "",
            };

            return (
              <FormikChangeEmailPage
                initialValues={initialValues}
                submit={async (values: ChangeEmailFormValues) => {
                  const response = await emailOtpRequest({
                    input: { email: values.email },
                  });

                  if (response === null) {
                    localStorage.setItem("email", values.email);
                    navigate(ROUTES.CHANGE_EMAIL_OTP);
                  }

                  return response;
                }}
              />
            );
          }}
        </ViewMe>
      )}
    </EmailOtpRequestController>
  );
};